"use client";

import EngineDateTable from "@/components/vrat/EngineDateTable";
import type { CalendarMasikShivratriItem } from "@/lib/api/calendar";

export interface MasikShivratriYearData {
  year: number;
  shivratris: CalendarMasikShivratriItem[];
}

export default function MasikShivratriDates({ years }: { years: MasikShivratriYearData[] }) {
  return (
    <EngineDateTable
      years={years.map(({ year, shivratris }) => ({ year, entries: shivratris }))}
      tabLabel="Shivratri"
      itemHeader="Masik Shivratri"
      detailHeader="Hindu month"
      emptyMessage="Masik Shivratri dates are computed live from the Vedic engine. The schedule could not be loaded right now — please refresh in a moment to see every Shivratri date with its lunar month."
      footer="All Masik Shivratri dates are computed from real planetary positions using the Swiss Ephemeris engine with Lahiri Ayanamsa — the Chaturdashi tithi boundary, not a fixed calendar."
    />
  );
}
